class MathFunction {
    calcZeroPointsBinary(start, end, points = 100) {
        let ret = [];
        let diff = end - start;
        for (var i = 0; i < points; i++) {
            let zeroPoint = this.binarySearch(start + diff * (i / points), start + diff * ((i + 1) / points), 0);
            if (!Number.isNaN(zeroPoint))
                ret.push(zeroPoint);
        }
        return ret;
    }

    binarySearch(start, end, value) {
        if (this.calc(start) > this.calc(end)) {
            let tmp = start;
            start = end;
            end = tmp;
        }
        if (Number.isNaN(start*1) || Number.isNaN(end*1) || value < this.calc(start) || value > this.calc(end))
            return Number.NaN;
        while (true) {
            let middle = start + (end - start) / 2;
            if (middle == start || middle == end) {//koniec dokładności floata
                return middle;
            }
            let calced = this.calc(middle);
            if (calced == value) {
                return middle;
            }
            if (calced < value) {
                start = middle;
            } else {
                end = middle;
            }
        }
    }

    calcZeroPointsRange(start, end, points = 100) {
        if (start > end) {
            let tmp = start;
            start = end;
            end = tmp;
        }
        try {
            let allExactpoints = this.calcZeroPoints();//jeśli istnieje w klasie, która dziedziczy z tej
            let ret = [];
            for (let x of allExactpoints) {
                if (x >= start && x <= end)
                    ret.push(x);
            }
            return ret;
        } catch (e) {
            return this.calcZeroPointsBinary(start, end, points);
        }
    }

    findMinMax(start, end, points = 100) {
        let min, max;
        let startValue = this.calc(start);
        let endValue = this.calc(end);
        if (startValue < endValue) {
            min = startValue;
            max = endValue;
        } else {
            min = endValue;
            max = startValue;
        }
        let zeroPoints = this.derriverance.calcZeroPointsRange(start, end, points);
        for (let x of zeroPoints) {
            let xValue = this.calc(x);
            if (xValue > max)
                max = xValue;
            else if (xValue < min)
                min = xValue;
        }
        return {min, max};
    }

    get derriverance() {
        throw new Error('not implemented yet');
    }
}

module.exports.MathFunction = MathFunction;